import { Typography } from '@mui/material';
import { styled } from '@mui/system';
import { useEffect, useState } from 'react';

import AboutUs from '../../components/AboutUs/AboutUs';
import WorkAccordion from '../../components/Accordion/WorkAccordion';
import BreadcrumbsComp from '../../components/Breadcrumbs/Breadcrumbs';
import ContactWork from '../../components/Contact/ContactWork';
import styles from '../../styles/Praca.module.scss';

const Praca = ({ jobs }) => {
  const [expand, setExpand] = useState([]);

  const showElement = (key) => {
    if (expand[key] === true) expand[key] = false;
    else expand[key] = true;
    setExpand((prev) => {
      let temp = prev;
      temp[3] = 'test';

      return temp;
    });
  };

  useEffect(() => {
    jobs.map((job) => setExpand((prev) => [...prev, false]));
  }, [jobs]);

  return (
    <>
      <div className={styles.breadcrumbsContainer}>
        <BreadcrumbsComp mainPage={true} typo={'praca'} />
      </div>
      <div className={styles.jobContainer}>
        <p className={styles.jobHeader}>Praca w TV Toya</p>
        <div className={styles.jobBody}>
          Zapraszamy do zapoznania się z naszymi aktualnymi ofertami pracy. Być
          może to właśnie Ty jesteś naszym przyszłym kolegą lub koleżanką!
        </div>
        {jobs.map((job, id) => (
          <WorkAccordion job={job} id={id} />
        ))}
      </div>
      <ContactWork />
      <AboutUs />
    </>
  );
};

export async function getServerSideProps() {
  const res = await fetch('https://webapi.toya.net.pl/v1/tvtoya/workOffers', {
    method: 'GET',
    mode: 'cors',
    headers: { Authorization: 'Basic dHZ0b3lhOkFZVnVmVUFyR2Y3TWtFTnY=' },
  });
  const jobs = await res.json();

  return { props: { jobs: jobs.data } };
}

export default Praca;
